import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useFormikContext } from 'formik';

import FormList from 'core/components/form-list';
import Property from './property';
import AddProperty from './add-property';

import useStyles from './properties-form.styles';

const PropertyForm = ({ classes, id, propertyType }) => {
  const { values } = useFormikContext();

  const isRentalProperty = propertyType === 'rental';
  const properties = isRentalProperty
    ? values.umbrellaCoverage?.rentalPropertyAddresses || []
    : values.umbrellaCoverage?.otherPropertyAddresses || [];

  return (
    <div className={classes.container}>
      <div className={classes.subtitleRow}>
        <h2 className={classes.sectionSubtitle}>
          {isRentalProperty ? 'Rental properties' : 'Additional residences (Non-Rental properties)'}
        </h2>
        <div className={classes.totalLabel}>
          <span className={classes.totalText}>TOTAL</span>
          <span className={classes.totalCount}>
            {properties?.length || 0} {isRentalProperty ? 'Rental properties' : 'Additional residences'}
          </span>
        </div>
      </div>
      {properties?.length === 0 && (
        <div className={classes.bannerContainer}>
          <div className={classes.noItemsBanner}>
            <p className={classes.noItemsTitle}>
              {isRentalProperty
                ? 'There are no rental properties added yet'
                : 'There are no additional residences added yet'}
            </p>
            <p className={classes.noItemsSubtitle}>To add one select from below</p>
          </div>
        </div>
      )}
      <div className={classes.searchContainer}>
        <FormList id={id} item={Property} addForm={AddProperty} showRightLabel={false} propertyType={propertyType} />
      </div>
    </div>
  );
};

function PropertiesForm({ id }) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <h1 className={classes.sectionTitle}>Properties</h1>
      <Grid container className={classes.propertyFormContainer}>
        <PropertyForm
          sectionTitle="Rental properties"
          classes={classes}
          id={`${id}.rentalPropertyAddresses`}
          propertyType="rental"
        />
      </Grid>
      <Grid container className={classes.propertyFormContainer}>
        <PropertyForm
          sectionTitle="Additional residences (Non-Rental properties)"
          classes={classes}
          id={`${id}.otherPropertyAddresses`}
          propertyType="nonRental"
        />
      </Grid>
    </div>
  );
}

PropertiesForm.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  propertyType: PropTypes.string.isRequired
};

export default PropertiesForm;
